module.exports = __webpack_public_path__ + "static/media/ic_check_filled.8ffb16e0.svg";